import { useContext } from 'react'
import { ValueContext } from './provider'

export const useValue = () => {
  const context = useContext(ValueContext)
  if (context === undefined) {
    throw new Error('useValue must be used within a ValueContextProvider')
  }
  return context
}
